<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>审批</el-breadcrumb-item>
      <el-breadcrumb-item>用章</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <RsljigouInternal :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigouInternal"></RsljigouInternal>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.yztype" placeholder="请选择" style="width: 100%">
              <el-option label="请选择用章类型" value="0"></el-option>
              <el-option label="公章" value="1"></el-option>
              <el-option label="合同章" value="2"></el-option>
              <el-option label="法人章" value="3"></el-option>
              <el-option label="财务章" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="经办人">
            <ChooseMultiErpUsersV2 ref="MultiErpUsers" @change="changeMultiErpUsers"></ChooseMultiErpUsersV2>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.yzfilename" @keyup.enter.native="clicksearch" placeholder="请输入文件名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.yzliyou" @keyup.enter.native="clicksearch" placeholder="请输入用印事由" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.yzbeizhu" @keyup.enter.native="clicksearch" placeholder="请输入备注" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="ShangJigouName" label="公司名称" min-width="10%"></el-table-column>
          <el-table-column prop="CurJigouName" label="申请部门" min-width="10%"></el-table-column>
          <el-table-column prop="Yztype" label="印章类型" min-width="5%"></el-table-column>
          <el-table-column prop="Yzfilename" label="文件名称" min-width="10%"></el-table-column>
          <el-table-column prop="Yzfilenum" label="文件份数" min-width="5%"></el-table-column>
          <el-table-column prop="Yzliyou" label="用印事由" min-width="9%"></el-table-column>
          <el-table-column prop="Createtime" label="用印日期" min-width="8%"></el-table-column>
          <el-table-column prop="Yzbeizhu" label="备注" min-width="9%"></el-table-column>
          <el-table-column label="附件" min-width="9%">
            <template v-slot="scope">
              <el-button v-for="Yzfileurl in scope.row.Yzfileurls" type="text" @click="clickfile(Yzfileurl)">点击查看</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="Yzstatusname" label="审核状态" min-width="6%"></el-table-column>
          <el-table-column prop="Name1" label="经办人" min-width="6%"></el-table-column>
          <el-table-column prop="Name2" label="副总经理" min-width="6%"></el-table-column>
          <el-table-column prop="Name3" label="总经理" min-width="6%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="10%">
            <template v-slot="scope">
              <el-button v-if="scope.row.Yzstatus == 1" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdel(scope.row)">删除</el-button>
              <el-button v-if="scope.row.Yzstatus == 1 && SubRule_ShenPiYongZhang_DanWei" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe1(scope.row)">副总经理审核</el-button>
              <el-button v-if="scope.row.Yzstatus == 2 && SubRule_ShenPiYongZhang_DanWeiZong" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe2(scope.row)">总经理审核</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <el-dialog
          title="审批"
          :visible.sync="dialogVisible"
          width="20%">
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="ShenHeOK">同意</el-button>
            <el-button type="danger" @click="ShenHeNO">拒绝</el-button>
          </span>
        </el-dialog>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="申请用章" name="second">
      <el-form :model="addForm" ref="addFormRef" label-width="170px">
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">印章类型(必选)</span>
          </label>
          <el-select v-model="addForm.yztype" placeholder="请选择" style="width: 100%">
            <el-option label="请选择" value="0"></el-option>
            <el-option label="公章" value="1"></el-option>
            <el-option label="合同章" value="2"></el-option>
            <el-option label="法人章" value="3"></el-option>
            <el-option label="财务章" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">文件名称(必填)</span>
          </label>
          <el-input v-model="addForm.yzfilename"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">文件份数(必填)</span>
          </label>
          <el-input v-model="addForm.yzfilenum"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">用印事由(必填)</span>
          </label>
          <el-input v-model="addForm.yzliyou"></el-input>
        </el-form-item>
        <el-form-item label="备注" class="addAdminForm">
          <el-input v-model="addForm.yzbeizhu"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">附件(必填)</span>
          </label>
          <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="addTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

  </el-tabs>
  </div>
</template>

<script>
import RsljigouInternal from '@/components/RsljigouInternal.vue'
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
import ChooseMultiErpUsersV2 from '@/components/ChooseMultiErpUsersV2.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    RsljigouInternal,
    ChooseMultiErpUsersV2,
    TencentyunCosUploadMultiImgOrPdf
  },
  name: 'MyShenPiYongZhang',
  data () {
    return {
      activeName: 'first',
      optionsproduct: [],
      addForm: {
        yztype: '0',
        yzfilename: '',
        yzfilenum: '',
        yzliyou: '',
        yzfileurl: '',
        yzbeizhu: ''
      },
      timer: '',
      // 查询
      keywords: {
        jigouid: '-1',
        jigouname: '',
        yztype: '0',
        createuserid: 0,
        yzfilename: '',
        yzliyou: '',
        yzbeizhu: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      dialogVisible: false,
      apiShenPiYongZhangSHUrl: '',
      yzid: 0,
      SubRule_ShenPiYongZhang_DanWei: false,
      SubRule_ShenPiYongZhang_DanWeiZong: false
    }
  },
  mounted () {
    this.apiGetShenPiYongZhangNum()
    this.apiGetShenPiYongZhangList()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiYongZhang_DanWei', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiYongZhang_DanWei = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiYongZhang_DanWeiZong', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiYongZhang_DanWeiZong = true
      }
    })
  },
  methods: {
    addTencentyunCosUploadMultiImgOrPdf (url) {
      this.addForm.yzfileurl = url
    },
    changeRsljigouInternal (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    changeMultiErpUsers (rv) {
      this.keywords.createuserid = rv
    },
    clickfile (url) {
      Vue.prototype.FunReviewFileurl(url, this.$router)
    },
    clickadd () {
      this.apiAddShenPiYongZhang()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    ShenHe1 (row) {
      this.dialogVisible = true
      this.apiShenPiYongZhangSHUrl = Vue.prototype.global.Url_ShenPiYongZhangSH1
      this.yzid = row.Id
    },
    ShenHe2 (row) {
      this.dialogVisible = true
      this.apiShenPiYongZhangSHUrl = Vue.prototype.global.Url_ShenPiYongZhangSH2
      this.yzid = row.Id
    },
    ShenHeOK () {
      this.dialogVisible = false
      this.apiShenPiYongZhangSH(1)
    },
    ShenHeNO () {
      this.dialogVisible = false
      this.apiShenPiYongZhangSH(-1)
    },
    clickdel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelShenPiYongZhang(row.Id)
      })
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetShenPiYongZhangNum()
      this.apiGetShenPiYongZhangList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetShenPiYongZhangList()
    },
    apiGetShenPiYongZhangNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.keywords.jigouid,
        yztype: that.keywords.yztype,
        createuserid: that.keywords.createuserid,
        yzfilename: that.keywords.yzfilename,
        yzliyou: that.keywords.yzliyou,
        yzbeizhu: that.keywords.yzbeizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiYongZhangNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetShenPiYongZhangList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        jigouid: that.keywords.jigouid,
        yztype: that.keywords.yztype,
        createuserid: that.keywords.createuserid,
        yzfilename: that.keywords.yzfilename,
        yzliyou: that.keywords.yzliyou,
        yzbeizhu: that.keywords.yzbeizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiYongZhangList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
            for (var i = 0; i < that.dataList.length; i++) {
              that.dataList[i].Yzfileurls = that.dataList[i].Yzfileurl.split('@@@')
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddShenPiYongZhang: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        yztype: that.addForm.yztype,
        yzfilename: that.addForm.yzfilename,
        yzfilenum: that.addForm.yzfilenum,
        yzliyou: that.addForm.yzliyou,
        yzfileurl: that.addForm.yzfileurl,
        yzbeizhu: that.addForm.yzbeizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddShenPiYongZhang, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiYongZhangNum()
            that.apiGetShenPiYongZhangList()

            // 清空添加
            that.addForm.yztype = '0'
            that.addForm.yzfilename = ''
            that.addForm.yzfilenum = ''
            that.addForm.yzliyou = ''
            that.addForm.yzfileurl = ''
            that.addForm.yzbeizhu = ''
            that.$refs.MultiImgOrPdf.cleardata()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelShenPiYongZhang: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        yzid: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelShenPiYongZhang, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiYongZhangNum()
            that.apiGetShenPiYongZhangList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiShenPiYongZhangSH: function (okorno) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        yzid: that.yzid,
        okorno: okorno
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(that.apiShenPiYongZhangSHUrl, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiYongZhangNum()
            that.apiGetShenPiYongZhangList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
